export const STATUS_CHIP_SOLID: Record<string, { label: string; className: string }> = {
  new:            { label: "New",            className: "bg-blue-500 text-white border-blue-400" },
  reviewing:      { label: "Reviewing",      className: "bg-violet-500 text-white border-violet-400" },
  applied:        { label: "Applied",        className: "bg-sky-500 text-sky-950 border-sky-400" },
  interviewing:   { label: "Interviewing",   className: "bg-amber-500 text-amber-950 border-amber-400" },
  offer_received: { label: "Offer Received", className: "bg-teal-500 text-white border-teal-400" },
  hired:          { label: "Hired",          className: "bg-emerald-500 text-emerald-950 border-emerald-400" },
  rejected:       { label: "Rejected",       className: "bg-red-500 text-white border-red-400" },
  not_relevant:   { label: "Not Relevant",   className: "bg-zinc-500 text-white border-zinc-400" },
  archived:       { label: "Archived",       className: "bg-zinc-700 text-zinc-200 border-zinc-600" },
};

/** Statuses that the backend enforces as terminal for TheirStackJobAssignment — a
 * further status update past this point is rejected (422), so the UI must not offer it. */
export const TERMINAL = new Set(["archived", "not_relevant"]);

export function daysAgo(iso: string | null | undefined): string {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
}

export function formatPostedDate(iso: string | null | undefined): string {
  if (!iso) return "";
  return new Date(iso).toLocaleString(undefined, {
    year: "numeric", month: "short", day: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  });
}
